










































import {Component, Vue} from "vue-property-decorator"
import {vxm} from "@/store"
import SiteImage from "@/components/SiteImage.vue"

@Component({components: {SiteImage}})
export default class AdminSiteList extends Vue {

  get sites() {
    return vxm.site.sites
  }

  async mounted() {
    await vxm.site.fetchSites(true)
  }

}
